module.exports = __webpack_public_path__ + "img/已使用图章@3x.380cb227.png";